import { KnopReactApp } from "@opstel/reactApp/reactApp";
import { BaseKnopClient, GetRequest, PostRequest, UrlParams } from "./baseKnopClient";
import { CorrelationId } from "@shared/telemetry/correlationId";

export class KnopHttpClient extends BaseKnopClient {
  protected readonly knopReactApp: KnopReactApp | undefined;

  constructor(
    protected readonly baseUrl: string,
    knopReactApp: KnopReactApp | undefined,
  ) {
    super();
    this.knopReactApp = knopReactApp;
  }

  async getToken(): Promise<string | null> {
    return this.knopReactApp ? this.knopReactApp.acquireToken() : null;
  }

  private async getHeaders(correlationId: CorrelationId): Promise<Record<string, string>> {
    const token = await this.getToken();
    return {
      "Content-Type": "text/plain",
      ...(token && { Authorization: `Bearer ${token}` }),
      ...CorrelationId.toHeaders(correlationId),
    };
  }

  private async request(
    url: string,
    options: Omit<RequestInit, "headers"> = {},
    urlParams: UrlParams = {},
    correlationId: CorrelationId,
  ): Promise<string> {
    const filteredParams = Object.entries(urlParams).filter((entry): entry is [string, string] => {
      const [key, value] = entry;
      if (value === undefined) console.warn(`Url parameter ${key} was undefined, filtered out`);
      return value !== undefined;
    });
    const headers = await this.getHeaders(correlationId);
    const response = await fetch(
      `${this.baseUrl}${url}?${new URLSearchParams(filteredParams).toString()}`,
      {
        ...options,
        headers,
      },
    );

    return await response.text();
  }

  async get({ url, urlParams, correlationId }: GetRequest): Promise<string> {
    return this.request(url, { method: "GET" }, urlParams, correlationId);
  }

  async post({ url, urlParams, data, correlationId }: PostRequest): Promise<string> {
    return this.request(url, { method: "POST", body: data }, urlParams, correlationId);
  }
}
